






















import Vue from 'vue';
import AttributeTitle from '../AttributeTitle.vue';
import ShowAll from '../components/showall/ShowAll.directive';
import DefaultPresenter from './DefaultPresenter.vue';
import CheckboxPresenter from './CheckboxPresenter.vue';
import DropdownPresenter from './DropdownPresenter.vue';
import PersonPresenter from './PersonPresenter.vue';
import DatePresenter from './DatePresenter.vue';
import RichTextPresenter from './RichTextPresenter.vue';

export default Vue.extend({
  name: 'Presenter',
  components: {
    AttributeTitle,
    DefaultPresenter,
    CheckboxPresenter,
    DropdownPresenter,
    PersonPresenter,
    DatePresenter,
    RichTextPresenter,
  },
  directives: {
    ShowAll,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    emitToggle(e) {
      this.$emit('toggle', e);
    },
    cell(attribute) {
      return {
        value: attribute.viewModel,
      };
    },
    row(attribute) {
      return {
        [attribute.name]: {
          value: attribute.viewModel,
        },
      };
    },
    col(attribute) {
      return {
        key: attribute.name,
        ...attribute,
        editable: !!attribute.editLink,
      };
    },
  },
});
